import * as userApi from '../api/users'
import { handleApiError } from './api-errors'

export const EDIT_USER = "EDIT_USER"
export const DELETE_USER = "DELETE_FAQ"
export const EDIT_CURRENT_USER = "EDIT_CURRENT_USER"
export const LIST_USERS = "LIST_USERS"

export const editUser = (user_id, userObj) => (dispatch) => {
    userApi.patchObj(user_id, userObj).then(res => {
        dispatch({
            type: EDIT_USER,
            payload: res
        })
    }).catch(err => dispatch(handleApiError(err)))
}

export const deleteUser = (user_id) => (dispatch, getState) => {
    userApi.deleteObj(user_id).then(res => {
        dispatch({
            type: DELETE_USER,
            payload: res
        })

    }).then(dispatch(listUsers())).catch(err => dispatch(handleApiError(err)))
}

export const listUsers = () => (dispatch) => {
    userApi.listObj().then(res => {
        dispatch({
            type: LIST_USERS,
            payload: res
        })
    }).catch(err => dispatch(handleApiError(err)))
}


export const editCurrentUser = (userObj) => (dispatch, getState) => {
    const userId = getState().auth.user._id
    userApi.patchObj(userId, userObj).then(res => {
        dispatch({
            type: EDIT_CURRENT_USER,
            payload: res
        })
    }).catch(err => dispatch(handleApiError(err)))
}

export const makeUserModerator = (user_id) => (dispatch) => {
    userApi.patchObj(user_id, {
        type: "moderator"
    }).then(res => {
        dispatch({
            type: EDIT_USER,
            payload: res
        })
    
    })
    .then(dispatch(listUsers()))
    .catch(err => dispatch(handleApiError(err)))
}


export const makeUserNormal = (user_id) => (dispatch) => {
    userApi.patchObj(user_id, {
        type: "normal"
    }).then(res => {
        dispatch({
            type: EDIT_USER,
            payload: res
        })
    })
    .then(dispatch(listUsers()))
    .catch(err => dispatch(handleApiError(err)))
}